// @TODO: implement bundle splitting here for pym
import { Parent } from "pym.js";

import { FB_JS_SDK_VERSION } from "config/constants";

var renderXFBML = function renderXFBML(block) {
  var element = document.querySelector(".block-" + block.key);
  window.FB.XFBML.parse(element);
};

var attachJWListerners = function attachJWListerners(htmlId, mediaId, isAutoplay) {
  // JW Player JS documentation
  // https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/
  var player = window.jwplayer(htmlId);
  var gaTimeout = void 0;
  var gaCalled = false;

  player.on("firstFrame", function () {
    // Turn on captions by default when the player starts playing.
    // Axios currently only uploads (and plans to upload) one captions track 2/2/2018
    // Note from JW: The caption at index of 0 will always be "off" and will always be returned even if no captions are present.
    // To turn off captions, use setCurrentCaptions(0)
    if (player.getCaptionsList().length > 1) {
      player.setCurrentCaptions(1);
    }
  });

  player.on("play", function () {
    // Ping GA if a video is played for longer than 3s
    // This is a JPMC KPI for Smarter Faster
    if (!gaCalled) {
      gaTimeout = setTimeout(function () {
        window.ga("send", {
          "hitType": "event",
          "eventCategory": "jw-player-3s-viewed",
          "eventAction": mediaId
        });
        gaCalled = true;
      }, 3000);
    }
  });

  player.on("pause", function () {
    // Clear 3s-viewed timeout if a video pauses
    // A pauses event fires if a user scrolls out of view
    clearTimeout(gaTimeout);
  });

  player.on("viewable", function (e) {
    // JW emits an event whenever a player scrolls in or out of view.
    // Play videos if they scroll into view
    // Pause if they scroll out of view
    if (e.viewable === 0) {
      player.pause(true);
    } else if (e.viewable === 1 && isAutoplay) {
      player.play(true);
    }
  });
};

export var handleEmbed = function handleEmbed(block) {
  var _block$data = block.data,
      oembed = _block$data.oembed,
      type = _block$data.type,
      _block$data$config = _block$data.config,
      config = _block$data$config === undefined ? {} : _block$data$config;


  switch (type) {
    case "facebook-post":
    case "facebook-video":
      {
        // Facebook sdk.js documentation
        // https://developers.facebook.com/docs/javascript
        // If Facebook's JS hasn't loaded, append it to the body of the doc,
        // then add an init function once it loads which renders embeds.
        // Otherwise, use FB's JS to render embeds
        if (!window.FB) {
          var script = document.createElement("script");
          script.setAttribute("src", "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v" + FB_JS_SDK_VERSION);
          document.body.appendChild(script);
          window.fbAsyncInit = function () {
            window.FB.init({ version: "v" + FB_JS_SDK_VERSION, xfbml: true });
            renderXFBML(block);
          };
        } else {
          renderXFBML(block);
        }
        break;
      }
    case "instagram":
      {
        // Instagram embed documentation
        // https://www.instagram.com/developer/embedding/
        var instgrm = window.instgrm;
        if (instgrm) instgrm.Embeds.process();
        break;
      }
    case "twitter":
      {
        // Twitter embed documentation
        // https://dev.twitter.com/web/embedded-tweets#render-a-tweet-with-javascript
        var twttr = window.twttr;
        if (twttr) twttr.widgets.load();
        break;
      }
    case "jwplayer-video":
      {
        // JW Player JS documentation
        // https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/
        var isAutoplay = config.autoplay;
        var playerId = isAutoplay ? oembed.autoplay_player_id : oembed.default_player_id;
        var htmlId = "botr_" + oembed.media_id + "_" + playerId + "_div";

        var jwEmbedScript = document.createElement("script");
        jwEmbedScript.setAttribute("src", "https://content.jwplatform.com/players/" + oembed.media_id + "-" + playerId + ".js");
        jwEmbedScript.setAttribute("type", "text/javascript");
        document.getElementById("jw-" + oembed.media_id).appendChild(jwEmbedScript);
        jwEmbedScript.onload = function () {
          attachJWListerners(htmlId, oembed.media_id, isAutoplay);
        };
        break;
      }
    case "axios-visual":
      {
        if (oembed.slug && oembed.url) new Parent(oembed.slug, oembed.url);
        break;
      }
    default:
      break;
  }
};


// WEBPACK FOOTER //
// ./src/utils/embed.js